let navBox = document.getElementById("nav-content");
let navOverlay = document.getElementById("modaloverlay");

/* toggle mobile nav */
document.getElementById('nav-toggle').onclick = function(){
    navBox.classList.toggle("hidden");
    navOverlay.classList.toggle("hidden");
    [].forEach.call(document.getElementsByClassName("toggleIcon"), function (el) {el.classList.toggle("hidden")});
}

/* hide mobile nav when clicked outside */
document.getElementById('modaloverlay').onclick = function(){
    navBox.classList.toggle("hidden");
    navOverlay.classList.toggle("hidden");
    [].forEach.call(document.getElementsByClassName("toggleIcon"), function (el) {el.classList.toggle("hidden")});
}

/* hide mobile nav on link click */
document.addEventListener("click", function(event) {
    if (event.target.closest("#nav-content a")){
        navBox.classList.toggle("hidden");
        navOverlay.classList.toggle("hidden");
        [].forEach.call(document.getElementsByClassName("toggleIcon"), function (el) {el.classList.toggle("hidden")});
    };
    /*if (event.target.closest("#headerNav")) return;
        if ( ! navBox.classList.contains("hidden") ){
        navBox.classList.toggle("hidden");
        [].forEach.call(document.getElementsByClassName("toggleIcon"), function (el) {el.classList.toggle("hidden")});
    }*/
});
const header = document.querySelector("header")
let scrolled = false;

let navScrollingToggle = function (event) {
    let scrollpos = window.scrollY;

    if (scrollpos < 1 && scrolled) { scrolled = false; header.classList.toggle('nav--scrolling'); }
    else if (scrollpos >= 1 && !scrolled) { scrolled = true; header.classList.toggle('nav--scrolling'); }
};

window.addEventListener('load', navScrollingToggle, false);
window.addEventListener('scroll', navScrollingToggle, false);
